export class Reference {
	packageSize: number | null;

	referenceBasketVersion: string;

	constructor(packageSize: number | null, referenceBasketVersion: string) {
		this.packageSize = packageSize;
		this.referenceBasketVersion = referenceBasketVersion;
	}
}
